export default __webpack_public_path__ + "static/rsz_a_kwoska-0881f193cfafee0385fe6dfb57b7cba8.jpg";